import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface CardProps {
  title?: string;
  icon?: LucideIcon;
  id?: string;
  /** Accessible name when the card has no visible title (the page header already names it). */
  ariaLabel?: string;
  /** Right-aligned content in the title row (counts, buttons). */
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function Card({ title, icon: Icon, id, ariaLabel, actions, className, children }: CardProps) {
  return (
    <section id={id} aria-label={title ?? ariaLabel} className={`rounded-2xl bg-white p-5 shadow-md ${className ?? ""}`}>
      {(title || actions) && (
        <div className="mb-4 flex items-center justify-between gap-3">
          <h2 className="flex items-center gap-2 text-[15px] font-semibold text-brand-navy">
            {Icon && <Icon size={18} className="shrink-0" aria-hidden="true" />}
            {title}
          </h2>
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}
